<template>
    <div id="item-container">
        <b-row>
            <b-col>
                <MdTitle
                    v-bind:Text="
                        this.editMode
                            ? $t('TestPanelSetupL.EditPanelSetup')
                            : $t('TestPanelSetupL.AddPanelSetup')
                    "
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12" v-if="false">
                <MdEdit
                    v-bind:Label="$t('Shared.Code')"
                    v-bind:Name="'Code'"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="15"
                    v-model="objecResultObj.code"
                    v-bind:Id="'input_code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('TestPanelSetupL.GroupName')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'groupName'"
                    v-bind:MaxLengthProp="100"
                    v-model="objecResultObj.groupName"
                    v-bind:Id="'input_description'"
                >
                </MdEdit>
            </b-col>

            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="'Loinc'"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'Loinc'"
                    v-model="objecResultObj.loincCode"
                    v-bind:Id="'input_loin'"
                    v-bind:MaxLengthProp="100"
                >
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="'SNOMED'"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'snoMedCode'"
                    v-model="objecResultObj.snoMedCode"
                    v-bind:Id="'input_snomed'"
                    v-bind:MaxLengthProp="100"
                >
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                 <MdEdit
                    v-bind:Label="$t('Shared.CPT')"
                    v-bind:Name="'CPT'"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="15"
                    v-model="objecResultObj.cptcode"
                    v-bind:Id="'input_cptcode'"
                />
                <!-- <MdLookup
                    v-bind:ModelCode="objecResultObj.cptcode"
                    v-bind:ModelDescription="dcpt"
                    v-bind:Label="$t('Shared.CPT')"
                    v-bind:RefCode="'cpt'"
                    v-bind:Api="'cpts'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'name'"
                    :SearchTitle="$t('Shared.CPT')"
                    :GetValues="onCodeConditionOk"
                    :InvalidFeedback="$t('rooms.cptRequired')"
                    :SearchFieldCode="'code'"
                /> -->
            </b-col>
        </b-row>
        <b-row>
            
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.UnitPrice')"
                    v-bind:TypeProp="'number'"
                    v-bind:Name="'unitPrice'"
                    v-bind:Min="'0'"
                    v-bind:StepProp="'0.01'"
                    v-model="objecResultObj.unitPrice"
                    v-money-prefix
                    v-bind:Id="'input_unitPrice'"
                >
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('Shared.Inactive')"
                    v-bind:Name="'Inactive'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="objecResultObj.isInactive"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col sm="12" class="mt-2">
                <MdTitle
                    v-bind:Text="$t('Shared.Details')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col class="col-sm-12 col-md-3">  
                <MdButton
                    v-bind:Label="$t('Shared.Add')"
                    v-bind:ClassProp="
                        this.isReadOnly
                            ? 'btn btn-primary my-3 btn-block'
                            : 'btn btn-primary my-3 btn-block btn-login'
                    "
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:click="addTest"
                >
                </MdButton>
            </b-col>
             <b-col class="col-sm-12 col-md-9 mb-4">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input 
                            type="text" 
                            class="form-control"
                            :dir="dirInput"
                            v-model="searchTest"
                            @keyup.enter="findTests"
                        >
                        <div class="input-group-append">
                            <MdButton 
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="findTests">
                            </MdButton>
                        </div>
                        </div>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <MdTablePaginationClient
                    v-bind:fields="fields"
                    v-bind:items="filteredTestCodes"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:IsItemReceived="true"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    :deleteIconEvent="RemoveTestResult"
                    v-bind:VisibleDeleteIcon="true"
                    :RowClick="RowClick"
                >
                </MdTablePaginationClient>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnBack'"
                v-bind:TextToolTip="$t('ePharmacyItemsReceived.BackToList')"
                v-on:click="goBack"
                v-bind:ClassProp="'mx-2 btn-login'"
            />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="this.isReadOnly ? 'primary mx-2' : 'primary btn-login mx-2'"
                v-on:click="SaveOrEdit"
                v-bind:isReadOnly="this.isReadOnly"
                v-bind:Name="'btn_save_inventory_item'"
            />
        </div>

        <ModalTableMultiSelectServer
            v-bind:Resource="resourceParameter"
            v-bind:TypeOption="refCode"
            @getCodeConditionOK="onCodeConditionAdd($event)"
            @getCodeConditionCancel="onCodeConditionCancel($event)"
            v-bind:Fields="lookupFields"
            v-bind:FieldCode="'code'"
            v-bind:FieldDescription="'name'"
            v-bind:TitleWindow="$t('TestOrder.TestSelectDialog.Title')"
            v-bind:ModalId="modalId"
            v-bind:ReturnAll="true"
        ></ModalTableMultiSelectServer>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';
import TestPanelSetupService from '@/services/testpanelsetup.service';
import TestOrderResultSetupService from '@/services/testorderresultsetup.service';
import CPTService from '@/services/cpt.service';
import Utils from '@/common/utils.js';

let elemSaveBtn = '';
export default {
    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('TestPanelSetupL.Title'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (!value) {
                        next();
                    } else {
                        this.SaveOrEdit();
                        next();
                    }
                });
        } else {
            next();
        }
    },

    mixins: [ShowMessage, DBFunctions],
    props: {
        editMode: Boolean
    },
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                Mode: this.editMode,
                favButtonAtion: false
            },

            isReadOnly: false,
            isEditable: true,
            objecResultObj: {
                code: '',
                groupName: '',
                loincCode: '',
                isInactive: false,
                snoMedCode: '',
                cptcode: '',
                unitPrice: null
            },
            dcpt: '',
            fields: [
                { key: 'name', sortable: true, label: this.$t('Shared.Name'), class: 'text-left' },
                { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'text-right' },
                {
                    key: 'cptcode',
                    sortable: true,
                    label: this.$t('DrugInventoryItem.CPTCode'),
                    class: 'text-right'
                },
                {
                    key: 'longName',
                    sortable: true,
                    label: this.$t('TestOrdersResultSetupL.LongD'),
                    class: 'text-left'
                }
            ],
            lookupFields: [
                { key: 'name', sortable: true, label: this.$t('Shared.Name'), class: 'text-left' },
                { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'text-right' },
                {
                    key: 'cptcode',
                    sortable: true,
                    label: this.$t('DrugInventoryItem.CPTCode'),
                    class: 'text-right'
                },
                {
                    key: 'longName',
                    sortable: true,
                    label: this.$t('TestOrdersResultSetupL.LongD'),
                    class: 'text-left'
                }
            ],
            // totalRows: 0,
            // showMessageIsEmpty: false,
            pageOptions: [5, 10, 15],
            perPage: 10,
            currentPage: 1,
            items: [],
            modalId: Utils.generateUUID(),
            resourceParameter: '',
            refCode: 'testOrder',
            searchTest: "",
            search: {
                tests: '',
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        };
    },

    computed: {
        testOrderAPI() {
            if (this.editMode) {
                return `PatientTestResultSetups?excludeTestPanelCode=${this.$route.params.id}`;
            }

            return 'PatientTestResultSetups';
        },

        filteredTestCodes() {
          
            const search = (this.search.tests || '').trim().toLowerCase();
            const list = this.items || [];

            if (!search) {
                return list;
            }
            
            return list.filter(item => {

                const name = (item.name || '').toLowerCase();
                const code = (item.code || '').toLowerCase();
                const longName          = (item.longName || '').toLowerCase();
                const cptcode        = (item.cptcode || '').toLowerCase();
                
                return  name.includes(search) || 
                        code.includes(search) || 
                        longName.includes(search) || 
                        cptcode.includes(search);
            });

        },

        totalRows() {
            return this.filteredTestCodes.length;
        },

        showMessageIsEmpty() {
            return this.totalRows === 0;
        },

    },

    methods: {
        onCodeConditionOk(result) {
            var type = result.FieldName;
            if (type.indexOf('cpt') >= 0) {
                this.dcpt = result.description;
                this.objecResultObj.cptcode = result.code;
            }
        },

        async getAllDescription() {
            if (this.objecResultObj.cptcode) {
                const CptParam = {
                    code: this.objecResultObj.cptcode
                };
                await CPTService.getCPTByCode(CptParam)
                    .then(response => {
                        if (response.status == '200' && response.data.length > 0) {
                            this.dcpt = response.data[0].name;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        goBack() {
            this.$router.push({ name: 'TestPanelSetupListing' });
        },

        SaveOrEdit() {
            if(this.items.length == 0){
                this.showMessage(this.$tc('Msg.Error'),this.$tc('TestPanelSetupL.ErrorTestNoSelected'),"errorAutoHide"); 
                return;
            } else if (!this.isReadOnly) {
                elemSaveBtn.setAttribute('disabled', '');

                if (this.editMode) {
                    this.update();
                } else {
                    this.save();
                }
            }
            
        },

        save() {
            const params = {
                ...this.objecResultObj,
                testOrderResults: this.items
            };
            TestPanelSetupService.add(params)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );

                        this.goBack();
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        update() {
            const params = {
                ...this.objecResultObj,
                testOrderResults: this.items
            };
            TestPanelSetupService.update(this.$route.params.id, params)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );

                        this.goBack();
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        async getTestPanelDetailsAsync() {
            if (this.editMode) {
                await TestOrderResultSetupService.getAllListing({
                    includeTestPanelCode: this.$route.params.id
                })
                    .then(async response => {
                        if (response.status == '200' && response.data) {
                            this.items = response.data;
                            let headerString = response.headers['x-pagination'];

                            if (headerString) {
                                const header = JSON.parse(headerString);
                                this.totalRows = header.TotalCount;
                            }
                        }

                        // this.showMessageIsEmpty = this.totalRows === 0 || this.items.length === 0;
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        async getTestPanelAsync() {
            if (this.editMode) {
                TestPanelSetupService.get(this.$route.params.id)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            this.objecResultObj = response.data;
                            this.getAllDescription();
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        pageChanged(page) {
            this.currentPage = page;
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            if (this.currentPage > (this.totalRows / this.perPage)) {
                this.currentPage = 1;
            }
        },

        onRowSelected() {},

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        },

        checkUserAction() {
            if (elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },

        onCodeConditionAdd(results) {
            this.$bvModal.hide(this.modalId);
            this.resourceParameter = '';

            if (!Array.isArray(results) || results.length === 0) {
                return;
            }

            let hasNewItems = false;

            results.forEach(result => {
                if (!result || !result.code) {
                    return;
                }

                const data = {
                    code: result.code.trim(),
                    name: result.name.trim(),
                    cptcode: result.cptcode?.trim(),
                    longName: result.longName?.trim()
                };

                const indexOf = this.items.findIndex(test => test.code === data.code);

                if (indexOf === -1) {
                    this.items.push(data);
                    hasNewItems = true;
                }
            });

            if (hasNewItems) {
                this.items.sort((a, b) => {
                    const x = a.name.toLowerCase();
                    const y = b.name.toLowerCase();
                    return x < y ? -1 : x > y ? 1 : 0;
                });
                this.pendingChanges = true;
                this.checkUserAction();
            }
        },

        onCodeConditionCancel() {
            this.resourceParameter = '';
        },

        addTest() {
            this.resourceParameter = '/' + this.testOrderAPI;
            this.modelFilter = {
                code: 1,
                description: this.$t('TestOrder.TestSelectDialog.TestPanels'),
                resource: this.testOrderAPI
            };
            this.$bvModal.show(this.modalId);
        },

        RemoveTestResult(row) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$t('Shared.PriorAuthorization'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        const indexOf = this.items.findIndex(test => test.code === row.code);

                        if (indexOf !== -1) {
                            this.items.splice(indexOf, 1);
                            this.pendingChanges = true;
                            this.totalRows = this.items.length;
                            this.checkUserAction();
                        }
                    }
                });
        },

        RowClick() {},

        findTests(){
            this.search.tests = this.searchTest;
            this.currentPage = 1;
        },
    },

    async mounted() {
        await Promise.allSettled([this.getTestPanelAsync(), this.getTestPanelDetailsAsync()]);
        setTimeout(
            function() {
                elemSaveBtn = document.getElementById('btn_save_inventory_item');
                elemSaveBtn.setAttribute('disabled', '');
            },
            50,
            this
        );
    },

    created() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
                this.checkUserAction();
            }.bind(this)
        );

        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    }
};
</script>
